import { configureStore } from '@reduxjs/toolkit';
import userReducer from './slices/user/UserSlice';
import thunk from 'redux-thunk';
import presentationReducer from './slices/presentation/PresentationSlice';
import MobileMenuSlice from './slices/mobileMenu/MobileMenuSlice';
import UserPanelSlice from './slices/userPanel/UserPanelSlice';
import EventSlice from './slices/event/EventSlice';
import StreamMapSlice from './slices/streamMap/StreamMapSlice';
import InactiveMapSlice from './slices/inactiveMap/InactiveMapSlice';
import LockViewSlice from './slices/lockView/LockViewSlice';
import CarouselSlice from './slices/Carousel/CarouselSlice';
import FeaturedEvent from './slices/FeaturedEvent/FeaturedEvent';
import FeaturedCategory from './slices/FeaturedCategory/FeaturedCategory';

export const store = configureStore({
  reducer: {
    user: userReducer,
    carousel: CarouselSlice,
    featured: FeaturedEvent,
    featured_category: FeaturedCategory,
    presentation: presentationReducer,
    mobileMenu: MobileMenuSlice,
    userPanel: UserPanelSlice,
    Event: EventSlice,
    StreamMap: StreamMapSlice,
    InactiveMap: InactiveMapSlice,
    LockView: LockViewSlice,
  },
  middleware: [thunk],
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
